import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';
import uid from 'uid';
import { orderCollection, orderCollectionPostDelete } from 'utils/ordering';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';

import * as actions from 'funnel/actions/question';

const getInitialState = {};

function reorderQuestions(state, id, thunk) {
  const toUpdate = state.items.get(id.toString());
  if (toUpdate) {
    return {
      ...state,
      items: orderCollection(
        state.items,
        id,
        toUpdate.order,
        thunk(toUpdate.order)
      ),
    };
  }

  return state;
}

const questions = createReducer(getInitialState, {
  [RECEIVE_FUNNEL](state, { funnel }) {
    const { steps } = funnel;
    const questions = steps.map(s => {
      return {
        ...s.question,
        order: s.step,
      };
    });

    return {
      ...state,
      items: Map(keyBy(questions, 'id')),
    };
  },
  [actions.CREATE_QUESTION](state, { fields }) {
    const question = {
      id: uid(),
      new: true,
      order: state.items.size + 1,
      ...fields,
    };

    return {
      ...state,
      items: state.items.set(question.id, question),
    };
  },
  [actions.UPDATE_QUESTION](state, { question }) {
    const items = state.items.set(question.id.toString(), question);

    return {
      ...state,
      items,
    };
  },
  [actions.MOVE_QUESTION_UP](state, { question }) {
    return reorderQuestions(state, question, order => order - 1);
  },
  [actions.MOVE_QUESTION_DOWN](state, { question }) {
    return reorderQuestions(state, question, order => order + 1);
  },
  [actions.DELETE_QUESTION](state, { question }) {
    return {
      ...state,
      items: orderCollectionPostDelete(
        state.items.remove(question.id.toString()),
        question.order
      ),
    };
  },
});

export default questions;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/questions.js